import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const antes = ['Pasabas más tiempo buscando que tejiendo.', 'Tenías ovillos guardados sin saber para qué usarlos.', 'Abrías Pinterest o Instagram y terminabas más confundida.', 'Empezabas proyectos que nunca terminabas.', 'Cuando por fin tenías tiempo libre… no sabías qué hacer.'];
const despues = ['Decides tu próximo proyecto en menos de 2 minutos.', 'Sabes exactamente qué tejer con la lana que ya tienes.', 'Cada sesión comienza con claridad y sin dudas.', 'Recuperas proyectos olvidados y vuelves a terminarlos.', 'Disfrutas el tiempo que antes desperdiciabas buscando ideas.'];
const mini = [{
  value: '+300',
  label: 'Páginas'
}, {
  value: '6',
  label: 'Tomos'
}, {
  value: '100%',
  label: 'Descargable'
}];
export function BeforeAfter() {
  return <section className="w-full bg-cream-2 px-4 py-14" data-id="element-29" data-mp="30pxbso8hwamc">
      <div className="mx-auto max-w-3xl text-center" data-id="element-30" data-mp="30pnm71rd45h6">
        <h2 className="font-display text-2xl font-black leading-tight text-plum-deep sm:text-4xl" data-id="element-31" data-mp="x40v6a886m5g">
          De pasar horas buscando…{' '}
          <span className="text-mauve" data-id="element-32" data-mp="t2fa41ljf1k6">a empezar a tejer en menos de 2 minutos.</span>
        </h2>

        <div className="mx-auto mt-6 max-w-md rounded-2xl bg-plum px-6 py-5 text-white shadow-lg" data-id="element-33" data-mp="172801up8pdr3">
          <span className="font-display text-4xl font-black text-mauve-soft" data-id="element-34" data-mp="1246f148974cz">
            +100
          </span>
          <p className="mt-1 text-sm leading-relaxed text-white/85" data-id="element-35" data-mp="eec7n26pe804">
            Horas recuperadas al año que antes perdías buscando ideas,
            comparando patrones o dudando qué proyecto comenzar.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-36" data-mp="jcnfj7dfu8fp">
        {/* Antes */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-plum/10 bg-white p-5" data-id="element-37" data-mp="3rsfhdm378a05">
          <h3 className="mb-4 text-center text-lg font-extrabold text-plum/60" data-id="element-38" data-mp="1qon19rfc1oz2">
            Antes
          </h3>
          <ul className="space-y-3" data-id="element-39" data-mp="20gj0x6x2hn5e">
            {antes.map(t => <li key={t} className="flex gap-3 text-sm text-plum/70" data-id="element-40" data-mp="20hcaefneuqr8">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-plum/10" data-id="element-41" data-mp="24h2y2ahn4qrj">
                  <XIcon className="h-3 w-3 text-plum/50" data-id="element-42" data-mp="17tg72s3c60lh" />
                </span>
                {t}
              </li>)}
          </ul>
        </motion.div>

        {/* Después */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border-2 border-mauve bg-white p-5 shadow-lg" data-id="element-43" data-mp="1grs1743evgio">
          <h3 className="mb-4 text-center text-lg font-extrabold text-mauve" data-id="element-44" data-mp="2x60e06ydqbh4">
            Con el Sistema ¿Qué Tejo Hoy?™
          </h3>
          <ul className="space-y-3" data-id="element-45" data-mp="379ypfgf1m81x">
            {despues.map(t => <li key={t} className="flex gap-3 text-sm font-medium text-plum" data-id="element-46" data-mp="32cortdhi2q30">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-mauve" data-id="element-47" data-mp="2xkf8igaw4o9p">
                  <CheckIcon className="h-3 w-3 text-white" data-id="element-48" data-mp="2tiag1kw6hxon" />
                </span>
                {t}
              </li>)}
          </ul>
        </motion.div>
      </div>

      <div className="mx-auto mt-8 grid max-w-md grid-cols-3 gap-3" data-id="element-49" data-mp="2jkmfgebw5vyk">
        {mini.map(m => <div key={m.label} className="rounded-xl bg-white py-4 text-center shadow-sm" data-id="element-50" data-mp="2eljf376uwdwx">
            <span className="font-display text-2xl font-black text-sage" data-id="element-51" data-mp="2alsop4l8rzsx">
              {m.value}
            </span>
            <p className="text-xs font-semibold text-plum/70" data-id="element-52" data-mp="ctwsrixwt76s">{m.label}</p>
          </div>)}
      </div>
    </section>;
}